(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4140],{

/***/ 8672:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/survey-closed",
      function () {
        return __webpack_require__(1545);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/BasePage/index.js + 5 modules
var BasePage = __webpack_require__(5159);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/StaticContext/index.js
var StaticContext = __webpack_require__(6787);
// EXTERNAL MODULE: ./node_modules/@sm/intl/dist/index.js
var dist = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/theming/dist/theming.esm.js
var theming_esm = __webpack_require__(1928);
// EXTERNAL MODULE: ./src/app/pages/SurveyClosed/BrandedSurveyClosed/index.tsx
var BrandedSurveyClosed = __webpack_require__(3100);
// EXTERNAL MODULE: ./src/app/pages/SurveyClosed/EUBrandedSurveyClosed/index.tsx
var EUBrandedSurveyClosed = __webpack_require__(8561);
// EXTERNAL MODULE: ./src/app/pages/SurveyClosed/NonBrandedSurveyClosed/index.tsx
var NonBrandedSurveyClosed = __webpack_require__(4966);
// EXTERNAL MODULE: ./src/app/components/BrandedEmbeddedHeader/index.ts + 1 modules
var BrandedEmbeddedHeader = __webpack_require__(4931);
;// CONCATENATED MODULE: ./src/app/pages/SurveyClosed/BrandedEmbeddedSurveyClosed/index.tsx




var COPY = (0,dist/* defineMessages */.vU)({
    BRANDED_EMBEDDED_COPY: {
        id: "SurveyClosed.BrandedEmbeddedSurveyClosed.DefaultMessage",
        defaultMessage: "This survey is closed.",
        description: "[Type: Header][Vis: high] - Informs the viewer that this survey has been closed"
    }
});
var BrandedEmbeddedSurveyClosed = function(param) {
    var _message = param.message, message = _message === void 0 ? (0,dist.t)(COPY.BRANDED_EMBEDDED_COPY) : _message;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandedEmbeddedHeader/* default */.Z, {
        message: message,
        utSource: "survey-closed"
    });
};
/* harmony default export */ var SurveyClosed_BrandedEmbeddedSurveyClosed = (BrandedEmbeddedSurveyClosed);

// EXTERNAL MODULE: ./src/app/components/EmbeddedNonBrandedHeader/index.tsx + 1 modules
var EmbeddedNonBrandedHeader = __webpack_require__(1915);
// EXTERNAL MODULE: ./src/app/styles/cmsTheme.ts
var cmsTheme = __webpack_require__(5169);
;// CONCATENATED MODULE: ./pages/survey-closed/index.page.tsx
/*
test case (MT1):
https://localmonkey.com/r2/survey-closed?sm=oJH2uafMAEw6Q2_2BDjw_2F8_2F4yWe0n_2Bf9YMne7Ds_2BgImuhYR7P4vs5XHiMcSDfo0491MTUPtcc3gsDWOwn7HGbCWgzxy0tDUe175EpAzdsgT5Q_3D
 */ 



// TODO: consider dropping the usage of BasePage










var index_page_COPY = (0,dist/* defineMessages */.vU)({
    DEFAULT_CLOSED_MESSAGE: {
        id: "survey-closed.closedMessage",
        defaultMessage: "This survey is currently closed.  Please contact the author of this survey for further assistance."
    },
    META_KEYWORDS: {
        id: "survey-closed.metaKeywords",
        defaultMessage: "questionnaire, questionnaires, questionaire, questionaires, free online survey, free online surveys"
    },
    CLOSED_PAGE_TITLE: {
        id: "survey-closed.title",
        defaultMessage: "Free Online Survey Software by SurveyMonkey: Closed Survey"
    },
    CLOSED_PAGE_NON_BRANDED_TITLE: {
        id: "survey-closed.nonBrandedTitle",
        defaultMessage: "Online Survey Software: Closed Survey"
    }
});
var SurveyClosedBody = function(param) {
    var defaultMessage = param.defaultMessage, isFetchSuccess = param.isFetchSuccess, isEmbedded = param.isEmbedded, isBrandingDisabled = param.isBrandingDisabled, isEUSubdomain = param.isEUSubdomain;
    if (!isFetchSuccess) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NonBrandedSurveyClosed/* default */.Z, {
            message: (0,dist.t)(index_page_COPY.DEFAULT_CLOSED_MESSAGE)
        });
    }
    if (isEmbedded) {
        return isBrandingDisabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbeddedNonBrandedHeader/* default */.Z, {
            message: defaultMessage,
            icon: "closed"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SurveyClosed_BrandedEmbeddedSurveyClosed, {
            message: defaultMessage
        });
    }
    if (isBrandingDisabled) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NonBrandedSurveyClosed/* default */.Z, {
            message: defaultMessage
        });
    }
    if (isEUSubdomain) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(EUBrandedSurveyClosed/* default */.Z, {
            message: defaultMessage
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandedSurveyClosed/* default */.Z, {
        message: defaultMessage
    });
};
var SurveyClosed = function(param) {
    var _fetchServerSideDataSuccess = param.fetchServerSideDataSuccess, fetchServerSideDataSuccess = _fetchServerSideDataSuccess === void 0 ? false : _fetchServerSideDataSuccess, pageOptions = param.pageOptions, collectorData = param.collectorData;
    var ref, ref1;
    // TODO: the majority of the data re-/assignments can take place before the rendering starts.
    // we're keeping the following as an incremental step from the existing logic.
    var ref2 = pageOptions || {}, canonicalName = ref2.canonical, _isNonBrandedSmParam = ref2.isNonBrandedSmParam, isNonBrandedSmParam = _isNonBrandedSmParam === void 0 ? false : _isNonBrandedSmParam, _isEmbeddedSmParam = ref2.isEmbeddedSmParam, isEmbeddedSmParam = _isEmbeddedSmParam === void 0 ? false : _isEmbeddedSmParam;
    var locale = (0,react.useContext)(StaticContext/* StaticContext */.vN).locale;
    var pathname = (0,router.useRouter)().pathname;
    var canonical = "".concat(canonicalName).concat(pathname);
    var collector = (collectorData || {}).collector;
    var closedMessage = ((collector === null || collector === void 0 ? void 0 : collector.closedPage) || {}).closedMessage;
    var isEmbedded = isEmbeddedSmParam || (collector === null || collector === void 0 ? void 0 : (ref = collector.type) === null || ref === void 0 ? void 0 : ref.toUpperCase()) === "POPUP";
    var isBrandingDisabled = isNonBrandedSmParam || (collector === null || collector === void 0 ? void 0 : (ref1 = collector.closedPage) === null || ref1 === void 0 ? void 0 : ref1.isBrandingDisabled) || (collector === null || collector === void 0 ? void 0 : collector.hideBranding);
    var showFooter = fetchServerSideDataSuccess && !isBrandingDisabled && !isEmbedded;
    var title = collector && !isBrandingDisabled && !locale.isEUSubdomain ? (0,dist.t)(index_page_COPY.CLOSED_PAGE_TITLE) : (0,dist.t)(index_page_COPY.CLOSED_PAGE_NON_BRANDED_TITLE);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(theming_esm/* ThemeProvider */.f6, {
        theme: cmsTheme/* default */.Z,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BasePage/* default */.Z, {
            includeHeader: false,
            includeFooter: showFooter,
            pageId: "Survey Closed",
            legacyWeb: "anonweb",
            includeExperiments: false,
            includeGTM: false,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("base", {
                            target: "_top",
                            href: "/"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "keywords",
                            content: (0,dist.t)(index_page_COPY.META_KEYWORDS)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "description",
                            content: (0,dist.t)(index_page_COPY.DEFAULT_CLOSED_MESSAGE)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            rel: "canonical",
                            href: canonical
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                            children: title
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SurveyClosedBody, {
                    defaultMessage: closedMessage || (0,dist.t)(index_page_COPY.DEFAULT_CLOSED_MESSAGE),
                    isFetchSuccess: fetchServerSideDataSuccess && collector !== null,
                    isBrandingDisabled: isBrandingDisabled,
                    isEUSubdomain: locale.isEUSubdomain,
                    isEmbedded: isEmbedded
                })
            ]
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var index_page = (SurveyClosed);


/***/ }),

/***/ 4931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ BrandedEmbeddedHeader_BrandedEmbeddedHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@sm/intl/dist/index.js
var dist = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/@sm/utils/dist/index.js
var utils_dist = __webpack_require__(7351);
// EXTERNAL MODULE: ./node_modules/react-jss/dist/react-jss.esm.js + 25 modules
var react_jss_esm = __webpack_require__(389);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/Logos/index.js + 3 modules
var Logos = __webpack_require__(7120);
// EXTERNAL MODULE: ./node_modules/@sm/metrics/dist/index.js
var metrics_dist = __webpack_require__(6431);
// EXTERNAL MODULE: ./node_modules/@wds/box/dist/index.es.js
var index_es = __webpack_require__(1743);
// EXTERNAL MODULE: ./node_modules/@wds/typography/dist/index.es.js
var dist_index_es = __webpack_require__(295);
// EXTERNAL MODULE: ./node_modules/@wds/button/dist/index.es.js + 1 modules
var button_dist_index_es = __webpack_require__(7837);
;// CONCATENATED MODULE: ./src/app/components/BrandedEmbeddedHeader/BrandedEmbeddedHeader.tsx










var COPY = (0,dist/* defineMessages */.vU)({
    BRANDED_EMBEDDED_POWERED_BY: {
        id: "BrandedEmbeddedHeader.BrandedEmbeddedHeader.PoweredBy",
        defaultMessage: "Powered by",
        description: "[Type: Label][Vis: med] - This figure of speech is used to introduce and display the SurveyMonkey Logo"
    },
    BRANDED_EMBEDDED_CTA: {
        id: "BrandedEmbeddedHeader.BrandedEmbeddedHeader.EmbeddedCTAText",
        defaultMessage: "Sign up free",
        description: "[Type: Label][Vis: med] - This is the phrase used inside a button that directs views to a signup page"
    },
    BRANDED_EMBEDDED_CTA_TITLE: {
        id: "BrandedEmbeddedHeader.BrandedEmbeddedHeader.EmbeddedCTATitle",
        defaultMessage: "Create surveys. Get answers.",
        description: "[Type: Label][Vis: low] - This text is here for accessibility reasons, it is usually hidden from users."
    },
    LOGO_ARIA_LABEL: {
        id: "BrandedEmbeddedHeader.BrandedEmbeddedHeader.LogoAriaLabel",
        defaultMessage: "SurveyMonkey home",
        description: "[Type: Header][Vis: med] - The SurveyMonkey Logo shown at the top of the page"
    }
});
var useStyles = (0,react_jss_esm/* createUseStyles */.QM)(function(theme) {
    return {
        embeddedContainer: {
            overflowY: "auto",
            width: "100%"
        },
        embeddedWrapper: {
            height: theme.util.fullHeight,
            minWidth: 300
        },
        headerContainer: {
            maxWidth: 300
        },
        logoWithText: {
            height: 23
        },
        ctaWrapper: {
            backgroundColor: theme.brandColors.neutral.slate,
            width: 280,
            minHeight: 102,
            borderRadius: 5
        }
    };
});
function BrandedEmbeddedHeader(param) {
    var message = param.message, utSource = param.utSource;
    var classes = useStyles();
    var utSource2 = "Embedded";
    var utSource3 = "BrandedEmbeddedHeader";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.x, {
        className: classes.embeddedWrapper,
        display: "flex",
        flexAlign: "center",
        flexJustify: "center",
        flexDirection: "column",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.x, {
            className: classes.embeddedContainer,
            display: "flex",
            flexAlign: "center",
            flexDirection: "column",
            py: 6,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.x, {
                    className: classes.headerContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_es/* Typography */.ZT, {
                        variant: "body",
                        align: "center",
                        "data-testid": "BrandedEmbeddedHeader__Text",
                        children: message
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.x, {
                    pt: 4,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_es/* Typography */.ZT, {
                        variant: "bodySm",
                        color: "darkMuted",
                        children: (0,dist.t)(COPY.BRANDED_EMBEDDED_POWERED_BY)
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.x, {
                    p: 2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        "aria-label": (0,dist.t)(COPY.LOGO_ARIA_LABEL),
                        "data-testid": "BrandedEmbeddedHeader__Goldie",
                        href: (0,utils_dist.createURL)("/", {
                            ut_source: utSource,
                            ut_source2: utSource2,
                            ut_source3: utSource3,
                            ut_ctatext: "LogoWithText"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logos/* LogoWithText */.u, {
                            className: classes.logoWithText
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.x, {
                    className: classes.ctaWrapper,
                    display: "flex",
                    flexAlign: "center",
                    flexJustify: "center",
                    flexDirection: "column",
                    p: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_es/* Typography */.ZT, {
                            color: "light",
                            component: "p",
                            align: "center",
                            children: (0,dist.t)(COPY.BRANDED_EMBEDDED_CTA_TITLE)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.x, {
                            mb: 1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_es/* Button */.zx, {
                            color: "alt",
                            size: "sm",
                            title: (0,dist.t)(COPY.BRANDED_EMBEDDED_CTA),
                            href: (0,utils_dist.createURL)("/user/sign-up/", {
                                ut_source: utSource,
                                ut_source2: utSource2,
                                ut_source3: utSource3,
                                ut_ctatext: (0,dist.t)(COPY.BRANDED_EMBEDDED_CTA)
                            }),
                            "data-sm-metric": (0,metrics_dist.generateMetricsAttribute)({
                                data: {
                                    actionType: "".concat(utSource, "_click_").concat(utSource2, "_cta_to_sign_up"),
                                    actionFlow: {
                                        utSource: utSource
                                    }
                                }
                            }),
                            target: "_blank",
                            children: (0,dist.t)(COPY.BRANDED_EMBEDDED_CTA)
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var BrandedEmbeddedHeader_BrandedEmbeddedHeader = (BrandedEmbeddedHeader);

;// CONCATENATED MODULE: ./src/app/components/BrandedEmbeddedHeader/index.ts



/***/ }),

/***/ 1915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ EmbeddedNonBrandedHeader_EmbeddedNonBrandedHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-jss/dist/react-jss.esm.js + 25 modules
var react_jss_esm = __webpack_require__(389);
// EXTERNAL MODULE: ./node_modules/@wds/box/dist/index.es.js
var index_es = __webpack_require__(1743);
// EXTERNAL MODULE: ./node_modules/@wds/typography/dist/index.es.js
var dist_index_es = __webpack_require__(295);
// EXTERNAL MODULE: ./node_modules/@wds/icons/dist/index.es.js
var icons_dist_index_es = __webpack_require__(9224);
;// CONCATENATED MODULE: ./src/app/components/EmbeddedNonBrandedHeader/EmbeddedNonBrandedHeader.tsx






var useStyles = (0,react_jss_esm/* createUseStyles */.QM)(function(theme) {
    return {
        embeddedContainer: {
            height: theme.util.fullHeight,
            backgroundColor: theme.endpageColors.embeddedNonBranded.backgroundColor
        },
        textContainer: {
            overflow: "auto"
        }
    };
});
function EmbeddedNonBrandedHeader(param) {
    var message = param.message, icon = param.icon;
    var ref = useStyles(), embeddedContainer = ref.embeddedContainer, textContainer = ref.textContainer;
    var Icon;
    switch(true){
        case icon === "closed":
            Icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_dist_index_es/* IconDanger */.Yf1, {
                color: "error",
                "data-testid": "EmbeddedNonBrandedHeader__ClosedIcon",
                size: "lg",
                title: "",
                "aria-hidden": "true"
            });
            break;
        case icon === "taken":
            Icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_dist_index_es/* IconMinusCircle */.WSJ, {
                color: "secondary",
                "data-testid": "EmbeddedNonBrandedHeader__TakenIcon",
                size: "lg",
                title: "",
                "aria-hidden": "true"
            });
            break;
        case icon === "thanks":
            Icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_dist_index_es/* IconCheckCircle */.Bu, {
                color: "primary",
                "data-testid": "EmbeddedNonBrandedHeader__ThanksIcon",
                size: "lg",
                title: "",
                "aria-hidden": "true"
            });
            break;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.x, {
        className: embeddedContainer,
        display: "flex",
        flexAlign: "center",
        flexJustify: "center",
        flexDirection: "column",
        px: 6,
        py: 6,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.x, {
                pb: 2,
                children: Icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.x, {
                px: 6,
                className: textContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_es/* Typography */.ZT, {
                    align: "center",
                    color: "darkMuted",
                    component: "div",
                    variant: "body",
                    "data-testid": "EmbeddedNonBrandedHeader__Text",
                    children: message
                })
            })
        ]
    });
}
/* harmony default export */ var EmbeddedNonBrandedHeader_EmbeddedNonBrandedHeader = (EmbeddedNonBrandedHeader);

;// CONCATENATED MODULE: ./src/app/components/EmbeddedNonBrandedHeader/index.tsx



/***/ }),

/***/ 482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ NonBrandedEndpageHeader_NonBrandedEndpageHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@wds/box/dist/index.es.js
var index_es = __webpack_require__(1743);
// EXTERNAL MODULE: ./node_modules/@wds/typography/dist/index.es.js
var dist_index_es = __webpack_require__(295);
// EXTERNAL MODULE: ./node_modules/@wds/icons/dist/index.es.js
var icons_dist_index_es = __webpack_require__(9224);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/SurveyTheme/context.js
var context = __webpack_require__(6322);
;// CONCATENATED MODULE: ./src/app/components/NonBrandedEndpageHeader/useStyles.ts

var useStyles = (0,context/* createSurveyStyles */.tF)({
    header: {
        boxSizing: "border-box",
        position: "fixed",
        top: "42vh",
        width: "100%"
    },
    icon: {
        marginRight: "0.5rem",
        "&> svg": {
            width: 40,
            height: 40
        }
    },
    boldText: {
        fontWeight: 500
    }
});
/* harmony default export */ var NonBrandedEndpageHeader_useStyles = (useStyles);

;// CONCATENATED MODULE: ./src/app/components/NonBrandedEndpageHeader/NonBrandedEndpageHeader.tsx






var NonBrandedEndpageHeader = function(param) {
    var copy = param.copy;
    var classes = NonBrandedEndpageHeader_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.x, {
        p: 6,
        className: classes.header,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_es/* Typography */.ZT, {
            align: "center",
            component: "section",
            variant: "sectionTitle",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: classes.icon,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_dist_index_es/* IconXCircle */.IF3, {
                        "data-testid": "NonBrandedEndpageHeader__Icon",
                        title: "Close"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    "data-testid": "NonBrandedEndpageHeader__Text",
                    className: classes.boldText,
                    children: copy
                })
            ]
        })
    });
};
/* harmony default export */ var NonBrandedEndpageHeader_NonBrandedEndpageHeader = (NonBrandedEndpageHeader);

;// CONCATENATED MODULE: ./src/app/components/NonBrandedEndpageHeader/index.ts



/***/ }),

/***/ 3100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _sm_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2497);
/* harmony import */ var _sm_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7351);
/* harmony import */ var _wds_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9224);
/* harmony import */ var _app_components_EndpageHeader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2398);
/* harmony import */ var _app_components_RebrandEpFormCore__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3715);
/* harmony import */ var _static_images_icons_perks_icon_white_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6782);
/* harmony import */ var _static_images_icons_enterprise_icon_white_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7455);
/* harmony import */ var _app_helpers_assetLoading__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98);










var COPY = (0,_sm_intl__WEBPACK_IMPORTED_MODULE_2__/* .defineMessages */ .vU)({
    ENDPAGE_HEADER_COPY: {
        id: "SurveyClosed.BrandedSurveyClosed.EndpageHeaderCopy",
        defaultMessage: "This survey is currently closed.",
        description: "[Type: Header][Vis: med] - Informs the viewer that this survey has been closed"
    },
    PRODUCT_CALLOUT_PERKS_HEADING: {
        id: "SurveyClosed.BrandedSurveyClosed.ProductCalloutPerksHeader",
        defaultMessage: "Is your company missing key perks?",
        description: "[Type: Header][Vis: med] - Tagline to help entice users to views click the cta below. The CTA leads to another signup page with minimal information."
    },
    PRODUCT_CALLOUT_PERKS_BODY: {
        id: "SurveyClosed.BrandedSurveyClosed.ProductCalloutPerkseBody",
        defaultMessage: "People love their work perks. Send a survey to find out if you’re offering the incentives employees and potential candidates want.",
        description: "[Type: Paragraph][Vis: med] - Gives context to the above Tagline"
    },
    PRODUCT_CALLOUT_PERKS_CTA: {
        id: "SurveyClosed.BrandedSurveyClosed.ProductCalloutPerksCTA",
        defaultMessage: "FIND OUT",
        description: "[Type: Button][Vis: med] - The text for a button which leads users to another sign up page"
    },
    PRODUCT_CALLOUT_ENTERPRISE_HEADING: {
        id: "SurveyClosed.BrandedSurveyClosed.ProductCalloutEnterpriseHeader",
        defaultMessage: "Take your business to the next level",
        description: "[Type: Header][Vis: med] - Tagline to help user learn more about SurveyMonkey Enterprise suite"
    },
    PRODUCT_CALLOUT_ENTERPRISE_BODY: {
        id: "SurveyClosed.BrandedSurveyClosed.ProductCalloutEnterpriseBody",
        defaultMessage: "Get access to powerful solutions that help you quickly collect feedback from your customers, prospects, and employees.",
        description: "[Type: Paragraph][Vis: med] - Expands on the above header line."
    },
    PRODUCT_CALLOUT_ENTERPRISE_CTA: {
        id: "SurveyClosed.BrandedSurveyClosed.ProductCalloutEnterpriseCTA",
        defaultMessage: "LEARN MORE",
        description: "[Type: Button][Vis: med] - The button text which leads users to a marketing page to learn more about SurveyMonkey's enterprise plans"
    }
});
var BrandedSurveyClosed = function(param) {
    var _message = param.message, message = _message === void 0 ? (0,_sm_intl__WEBPACK_IMPORTED_MODULE_2__.t)(COPY.ENDPAGE_HEADER_COPY) : _message;
    var utSource = "survey-closed";
    var utSource2 = "RebrandEpForm";
    var utSource3 = "ProductCalloutItem";
    var CALLOUT_ITEM_SIGN_UP = {
        icon: (0,_app_helpers_assetLoading__WEBPACK_IMPORTED_MODULE_9__/* .getSrc */ .d)(_static_images_icons_perks_icon_white_svg__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z),
        heading: (0,_sm_intl__WEBPACK_IMPORTED_MODULE_2__.t)(COPY.PRODUCT_CALLOUT_PERKS_HEADING),
        copy: (0,_sm_intl__WEBPACK_IMPORTED_MODULE_2__.t)(COPY.PRODUCT_CALLOUT_PERKS_BODY),
        href: (0,_sm_utils__WEBPACK_IMPORTED_MODULE_3__.createURL)("/user/sign-up/", {
            ut_source: utSource,
            ut_source2: utSource2,
            ut_source3: utSource3,
            ut_ctatext: (0,_sm_intl__WEBPACK_IMPORTED_MODULE_2__.t)(COPY.PRODUCT_CALLOUT_PERKS_CTA)
        }),
        cta: (0,_sm_intl__WEBPACK_IMPORTED_MODULE_2__.t)(COPY.PRODUCT_CALLOUT_PERKS_CTA),
        ctaColor: "sabaeus",
        name: "perks"
    };
    var CALLOUT_ITEM_ENTERPRISE = {
        icon: (0,_app_helpers_assetLoading__WEBPACK_IMPORTED_MODULE_9__/* .getSrc */ .d)(_static_images_icons_enterprise_icon_white_svg__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z),
        heading: (0,_sm_intl__WEBPACK_IMPORTED_MODULE_2__.t)(COPY.PRODUCT_CALLOUT_ENTERPRISE_HEADING),
        copy: (0,_sm_intl__WEBPACK_IMPORTED_MODULE_2__.t)(COPY.PRODUCT_CALLOUT_ENTERPRISE_BODY),
        href: (0,_sm_utils__WEBPACK_IMPORTED_MODULE_3__.createURL)("/mp/enterprise/", {
            ut_source: utSource,
            ut_source2: utSource2,
            ut_source3: utSource3,
            ut_ctatext: (0,_sm_intl__WEBPACK_IMPORTED_MODULE_2__.t)(COPY.PRODUCT_CALLOUT_ENTERPRISE_CTA)
        }),
        cta: (0,_sm_intl__WEBPACK_IMPORTED_MODULE_2__.t)(COPY.PRODUCT_CALLOUT_ENTERPRISE_CTA),
        ctaColor: "midnight",
        name: "enterprise"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_EndpageHeader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                copy: message,
                headerColor: "midnight",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wds_icons__WEBPACK_IMPORTED_MODULE_4__/* .IconXCircle */ .IF3, {
                    "aria-hidden": "true",
                    title: ""
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_RebrandEpFormCore__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                utSource: utSource,
                calloutItem1: CALLOUT_ITEM_SIGN_UP,
                calloutItem2: CALLOUT_ITEM_ENTERPRISE
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BrandedSurveyClosed);


/***/ }),

/***/ 8561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _sm_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2497);
/* harmony import */ var _sm_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7351);
/* harmony import */ var _wds_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9224);
/* harmony import */ var _app_components_EndpageHeader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2398);
/* harmony import */ var _app_components_RebrandEpFormCore__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3715);
/* harmony import */ var _static_images_icons_perks_icon_white_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6782);
/* harmony import */ var _static_images_icons_msg_icon_white_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4669);
/* harmony import */ var _app_helpers_assetLoading__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98);










var COPY = (0,_sm_intl__WEBPACK_IMPORTED_MODULE_2__/* .defineMessages */ .vU)({
    ENDPAGE_HEADER_COPY: {
        id: "SurveyClosed.EUBrandedSurveyClosed.EndpageHeaderCopy",
        defaultMessage: "This survey is currently closed.",
        description: "[Type: Header][Vis: med] - Informs the viewer that this survey has been closed"
    },
    PRODUCT_CALLOUT_PERKS_HEADING: {
        id: "SurveyClosed.EUBrandedSurveyClosed.ProductCalloutPerksHeader",
        defaultMessage: "Is your company missing key perks?",
        description: "[Type: Header][Vis: med] - Tagline to help entice users to views click the cta below. The CTA leads to another signup page with minimal information."
    },
    PRODUCT_CALLOUT_PERKS_BODY: {
        id: "SurveyClosed.EUBrandedSurveyClosed.ProductCalloutPerksBody",
        defaultMessage: "People love their work perks. Send a survey to find out if you’re offering the incentives employees and potential candidates want.",
        description: "[Type: Paragraph][Vis: med] - Gives context to the above Tagline"
    },
    PRODUCT_CALLOUT_PERKS_CTA: {
        id: "SurveyClosed.EUBrandedSurveyClosed.ProductCalloutPerksCTA",
        defaultMessage: "FIND OUT",
        description: "[Type: Button][Vis: med] - The text for a button which leads users to another sign up page"
    },
    PRODUCT_CALLOUT_COLLABORATION_HEADING: {
        id: "SurveyClosed.EUBrandedSurveyClosed.ProductCalloutCollaborationEUHeader",
        defaultMessage: "Are your customers satisfied?",
        description: "[Type: Header][Vis: med] - Tag line to help user learn more about SurveyMonkey Collaboration"
    },
    PRODUCT_CALLOUT_COLLABORATION_BODY: {
        id: "SurveyClosed.EUBrandedSurveyClosed.ProductCalloutCollaborationEUBody",
        defaultMessage: "83% of businesses who describe themselves as “successful” actively measure customer satisfaction.",
        description: "[Type: Paragraph][Vis: med] - Expands and reiterate the above header line."
    },
    PRODUCT_CALLOUT_COLLABORATION_CTA: {
        id: "SurveyClosed.EUBrandedSurveyClosed.ProductCalloutCollaborationEUCTA",
        defaultMessage: "GET STARTED",
        description: "[Type: Button][Vis: med] - The button text which leads users to a marketing page to learn more about SurveyMonkey' premium plans"
    }
});
var EUBrandedSurveyClosed = function(param) {
    var _message = param.message, message = _message === void 0 ? (0,_sm_intl__WEBPACK_IMPORTED_MODULE_2__.t)(COPY.ENDPAGE_HEADER_COPY) : _message;
    var utSource = "survey-closed";
    var utSource2 = "RebrandEpFormIntl";
    var utSource3 = "ProductCalloutItem";
    var CALLOUT_ITEM_SIGN_UP = {
        icon: (0,_app_helpers_assetLoading__WEBPACK_IMPORTED_MODULE_9__/* .getSrc */ .d)(_static_images_icons_perks_icon_white_svg__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z),
        heading: (0,_sm_intl__WEBPACK_IMPORTED_MODULE_2__.t)(COPY.PRODUCT_CALLOUT_PERKS_HEADING),
        copy: (0,_sm_intl__WEBPACK_IMPORTED_MODULE_2__.t)(COPY.PRODUCT_CALLOUT_PERKS_BODY),
        href: (0,_sm_utils__WEBPACK_IMPORTED_MODULE_3__.createURL)("/user/sign-up/", {
            ut_source: utSource,
            ut_source2: utSource2,
            ut_source3: utSource3,
            ut_ctatext: (0,_sm_intl__WEBPACK_IMPORTED_MODULE_2__.t)(COPY.PRODUCT_CALLOUT_PERKS_CTA)
        }),
        cta: (0,_sm_intl__WEBPACK_IMPORTED_MODULE_2__.t)(COPY.PRODUCT_CALLOUT_PERKS_CTA),
        ctaColor: "sabaeus",
        name: "perks"
    };
    var CALLOUT_ITEM_COLLABORATION = {
        icon: (0,_app_helpers_assetLoading__WEBPACK_IMPORTED_MODULE_9__/* .getSrc */ .d)(_static_images_icons_msg_icon_white_svg__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z),
        heading: (0,_sm_intl__WEBPACK_IMPORTED_MODULE_2__.t)(COPY.PRODUCT_CALLOUT_COLLABORATION_HEADING),
        copy: (0,_sm_intl__WEBPACK_IMPORTED_MODULE_2__.t)(COPY.PRODUCT_CALLOUT_COLLABORATION_BODY),
        href: (0,_sm_utils__WEBPACK_IMPORTED_MODULE_3__.createURL)("/mp/collaboration/", {
            ut_source: utSource,
            ut_source2: utSource2,
            ut_source3: utSource3,
            ut_ctatext: (0,_sm_intl__WEBPACK_IMPORTED_MODULE_2__.t)(COPY.PRODUCT_CALLOUT_COLLABORATION_CTA)
        }),
        ctaColor: "concord",
        cta: (0,_sm_intl__WEBPACK_IMPORTED_MODULE_2__.t)(COPY.PRODUCT_CALLOUT_COLLABORATION_CTA),
        name: "collaboration"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_EndpageHeader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                copy: message,
                headerColor: "sabaeus",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wds_icons__WEBPACK_IMPORTED_MODULE_4__/* .IconXCircle */ .IF3, {
                    "aria-hidden": "true",
                    title: ""
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_RebrandEpFormCore__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                utSource: utSource,
                calloutItem1: CALLOUT_ITEM_SIGN_UP,
                calloutItem2: CALLOUT_ITEM_COLLABORATION,
                hideCTAs: true
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EUBrandedSurveyClosed);


/***/ }),

/***/ 4966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _sm_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2497);
/* harmony import */ var _app_components_NonBrandedEndpageHeader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(482);




var COPY = (0,_sm_intl__WEBPACK_IMPORTED_MODULE_2__/* .defineMessages */ .vU)({
    NONBRANDED_ENDPAGEHEADER_COPY: {
        id: "SurveyClosed.NonBrandedSurveyClosed.NonBrandedEndpageHeader",
        defaultMessage: "This survey is closed. Please contact the author of this survey for further assistance.",
        description: "[Type: Header][Vis: high] - Informs the viewer that this survey has been closed"
    }
});
var NonBrandedSurveyClosed = function(param) {
    var _message = param.message, message = _message === void 0 ? (0,_sm_intl__WEBPACK_IMPORTED_MODULE_2__.t)(COPY.NONBRANDED_ENDPAGEHEADER_COPY) : _message;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_NonBrandedEndpageHeader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        copy: message
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NonBrandedSurveyClosed);


/***/ }),

/***/ 1163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(387)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3372,9811,3649,7517,4693,9921,4844,6399,4542,9774,2888,179], function() { return __webpack_exec__(8672); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);